import React, { ReactNode } from "react";
import { Modal } from "react-bootstrap";

interface IProps {
  show: boolean;
  onClose: () => void;
  actions?: ReactNode
}

const ConfirmationModal = (props: IProps) => {
  const { actions, show, onClose } = props;

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Log-in required</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>You must be signed in in order to save an order.</p>
      </Modal.Body>

      <Modal.Footer>
        {
          actions
        }
      </Modal.Footer>
    </Modal>
  )
}

export default ConfirmationModal;
